import * as React from 'react';

interface IProps {
  fillColor: string;
  className: string;
}

const defaultProps = {
  className: '',
  fillColor: '#53585E',
};

const AddMusicIcon = ({
  fillColor,
  className,
}: IProps): React.ReactElement<React.ReactNode> => (
  <svg viewBox="0 0 30 23" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-553 -361)">
        <g transform="translate(553 361)">
          <g transform="translate(7.5)" fill={fillColor}>
            <g>
              <path d="M20.2496943,3.24750917 L20.2496943,14.685631 C19.7314469,14.5036634 19.1507442,14.4017333 18.5375051,14.4017333 C16.3490796,14.4017333 14.5750102,15.6998272 14.5750102,17.3011071 C14.5750102,18.9023871 16.3490796,20.2004809 18.5375051,20.2004809 C20.5921966,20.2004809 22.281627,19.0561916 22.4804351,17.5910445 L22.5,2.07863961 L22.5,2.13162821e-14 L6.35650224,3.19082127 L6.35650224,4.97876846 L6.35650224,17.2950674 C5.83825486,17.1130998 5.2575522,17.0111697 4.64431308,17.0111697 C2.45588758,17.0111697 0.681818182,18.3092636 0.681818182,19.9105435 C0.681818182,21.5118235 2.45588758,22.8099174 4.64431308,22.8099174 C6.69900462,22.8099174 8.38843503,21.6656281 8.58724307,20.2004809 L8.606808,5.54876815 L20.2496943,3.24750917 Z" />
            </g>
          </g>
          <g transform="translate(0 3.833)">
            <ellipse
              fill={fillColor}
              cx="5.625"
              cy="5.75"
              rx="5.625"
              ry="5.75"
            />
            <path
              d="M5.12541094,5.23930896 L5.12541094,3.33935518 C5.12541094,3.0828989 5.33998764,2.875 5.58799313,2.875 C5.84347021,2.875 6.05057531,3.09051194 6.05057531,3.33935518 L6.05057531,5.23930896 L7.89021228,5.23930896 C8.15159428,5.23930896 8.36348625,5.45865403 8.36348625,5.71217075 C8.36348625,5.97332511 8.15265935,6.18503254 7.89021228,6.18503254 L6.05057531,6.18503254 L6.05057531,8.08498632 C6.05057531,8.3414426 5.83599861,8.5493415 5.58799313,8.5493415 C5.33251604,8.5493415 5.12541094,8.33382956 5.12541094,8.08498632 L5.12541094,6.18503254 L3.28577397,6.18503254 C3.02439197,6.18503254 2.8125,5.96568747 2.8125,5.71217075 C2.8125,5.45101639 3.0233269,5.23930896 3.28577397,5.23930896 L5.12541094,5.23930896 Z"
              stroke="#FFF"
              strokeWidth="0.688"
              fill="#FFF"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

AddMusicIcon.defaultProps = defaultProps;

export { AddMusicIcon };
